import { gql } from "@apollo/client/core";
import { CUSTOMER_USER_ERROR_FRAGMENT, CustomerUserError } from "./fragments";

export type CustomerAccessTokenCreateMutation = {
  customerAccessTokenCreate: {
    customerAccessToken: {
      accessToken: string;
    };
    customerUserErrors: CustomerUserError[];
  };
};

export const CUSTOMER_ACCESS_TOKEN_CREATE_MUTATION = gql`
  mutation CustomerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
      }
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }

  ${CUSTOMER_USER_ERROR_FRAGMENT}
`;

export type CustomerUpdateMutation = {
  customerUpdate: {
    customerUserErrors: CustomerUserError[];
  };
};

export const CUSTOMER_UPDATE_MUTATION = gql`
  mutation CustomerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
    customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }

  ${CUSTOMER_USER_ERROR_FRAGMENT}
`;

export type CustomerRecoverMutation = {
  customerRecover: {
    customerUserErrors: CustomerUserError[];
  };
};

export const CUSTOMER_RECOVER_MUTATION = gql`
  mutation CustomerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        ...CustomerUserErrorFragment
      }
    }
  }

  ${CUSTOMER_USER_ERROR_FRAGMENT}
`;
